import actions from './actions';
import RequestStatusKeys from './requestStatusKeys';

export { default as ServiceUrls } from './urls';

export const RequestStatusMutationTypes = {
	LOADING: 'REQUEST_STATUS_LOADING',
	SUCCESS: 'REQUEST_STATUS_SUCCESS',
	ERROR: 'REQUEST_STATUS_ERROR'
};

const createInitialState = () => {
	const initialStateMap = {};
	Object.keys(RequestStatusKeys).forEach(key => {
		const entry = RequestStatusKeys[key];
		initialStateMap[entry.key] = {
			loading: false,
			data: entry.defaultValue,
			error: null,
		};
	});

	return initialStateMap;
};

const mutations = {
	[RequestStatusMutationTypes.LOADING](state, requestStatus) {
		const request = state[requestStatus.key];
		request.loading = true;
		request.data = requestStatus.defaultValue;
		request.error = null;
	},
	[RequestStatusMutationTypes.SUCCESS](state, { requestStatus, data }) {
		const request = state[requestStatus.key];
		request.loading = false;
		request.data = data;
		request.error = null;
	},
	[RequestStatusMutationTypes.ERROR](state, { requestStatus, error }) {
		const request = state[requestStatus.key];
		request.loading = false;
		request.data = requestStatus.defaultValue;
		request.error = error;
	},
};

const store = {
	mutations,
	state: createInitialState,
	actions
};

export {
	store,
	RequestStatusKeys
};
